import { Provider } from '@/modules/provider/entities/interfaces/provider';
import restfulBase from '@/services/negotiations/core/base';

const apiService = restfulBase('providers');

export const providerInitalState: Provider = {
  name: '',
  cnpj: '',
};

export default apiService;
